// @packages
import AppBar from '@material-ui/core/AppBar';
import Collapse from '@material-ui/core/Collapse';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import PropTypes from 'prop-types';
import React from 'react';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';

// @scripts
import CtrlMenuItem from './menu-item';
import { config } from '../../../../config';

// @styles
import styles from './styles';

const CtrlMainMenu = ({
    className,
    classes,
    currentUrl,
    id,
    isExpanded,
    isPendingScheduleImport,
    onCollapse,
    onExpand,
    sessionId,
    visible
}) => {
    if (!visible) {
        return null;
    }

    const mainMenuClass = classNames(
        className,
        classes.mainMenu
    );

    const paperClass = isExpanded
        ? classes.menuPaper
        : classes.menuPaperCollapsed;

    const handleToggleSideMenu = () => isExpanded ? onCollapse() : onExpand();
    return (
        <Collapse id={`${id}-menu-collapser`} in timeout="auto">
            <Drawer
                className={mainMenuClass}
                classes={{ paper: paperClass }}
                id={id}
                open
                variant="persistent"
            >
                <AppBar position="static">
                    <Toolbar>
                        <IconButton
                            aria-label="menu"
                            className={classes.menuButton}
                            color="inherit"
                            edge="start"
                            onClick={handleToggleSideMenu}
                        >
                            <MenuIcon />
                        </IconButton>
                        <Typography className={classes.title} variant="h6" color="inherit">
                            {isExpanded && config.text.common.mainMenu}
                        </Typography>
                    </Toolbar>
                </AppBar>
                {
                    config.mainMenu.map((menuItem, index) => (((menuItem.permission === 'auth' && sessionId)
                        || !menuItem.permission)
                        && (
                            <CtrlMenuItem
                                currentUrl={currentUrl}
                                icon={menuItem.icon}
                                id={`${id}-${menuItem.name.toLowerCase()}-menuitem`}
                                isExpanded={isExpanded}
                                isInternal={menuItem.isInternal}
                                key={index}
                                label={menuItem.description}
                                name={menuItem.name}
                                promptBeforeNavigate={menuItem.name === 'selnav'
                                    && (!menuItem.isInternal && isPendingScheduleImport)}
                                sessionId={sessionId}
                                url={menuItem.url}
                            />
                        )
                    ))
                }
            </Drawer>
        </Collapse>
    );
};

CtrlMainMenu.propTypes = {
    className: PropTypes.string,
    classes: PropTypes.object.isRequired,
    currentUrl: PropTypes.string,
    id: PropTypes.string.isRequired,
    isExpanded: PropTypes.bool.isRequired,
    isPendingScheduleImport: PropTypes.bool,
    onCollapse: PropTypes.func.isRequired,
    onExpand: PropTypes.func.isRequired,
    sessionId: PropTypes.string,
    visible: PropTypes.bool
};

CtrlMainMenu.defaultProps = {
    className: null,
    currentUrl: null,
    isPendingScheduleImport: false,
    sessionId: null,
    visible: true
};

const mapStateToProps = ({ user, product }) => ({
    isPendingScheduleImport: Boolean(product.scheduleItems.length > 0),
    sessionId: user.sid
});

export default connect(mapStateToProps)(withStyles(styles)(CtrlMainMenu));
